import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-pressed", "aria-label", "onClick"]


export default {
  __name: 'WeekdayPicker',
  props: {
  modelValue: { type: Array, default: () => [] },
  days: { type: Array, required: true },
  label: { type: String, default: 'Days' }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const toggle = value => {
  const picked = props.modelValue.includes(value)
    ? props.modelValue.filter(day => day !== value)
    : [...props.modelValue, value]
  emit('update:modelValue', picked)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-wrap gap-2",
    role: "group",
    "aria-label": __props.label
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (day) => {
      return (_openBlock(), _createElementBlock("button", {
        key: day.value,
        type: "button",
        "aria-pressed": __props.modelValue.includes(day.value),
        "aria-label": day.long,
        class: _normalizeClass(["min-w-[3.25rem] rounded-full border px-4 py-[9px] text-sm transition", 
        __props.modelValue.includes(day.value)
          ? 'border-gray-900 bg-gray-900 font-semibold text-white'
          : 'border-gray-300 bg-white text-gray-900 hover:border-gray-400'
      ]),
        onClick: $event => (toggle(day.value))
      }, _toDisplayString(day.label), 11, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

}